
/* injects from baggage-loader */

import React, { useMemo } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { Link } from "react-router";
import { createSelector } from "reselect";
import { getSportsListSubscriptionRequest } from "../../../helpers/terminalRequests/virtualSportsHelpers";
import { t } from "../../../helpers/translator";
import { getSwarmDataKeyForRequest, SwarmDataMixin } from "../../../mixins/swarmDataMixin";
import { UIMixin } from "../../../mixins/uiMixin";

const virtualSports = ['VirtualHorseRacing', 'VirtualGreyhoundRacing'];

const CasinoAndVirtualGameLinks = ({ skinType, data: { sport } = {} }) => {
    const sports = useMemo(() => {
        if (!sport) return [];

        const virtuals = _.pickBy(sport, item => virtualSports.includes(item.alias));
        return Object.values(virtuals);
    }, [sport]);

    return (
        <div className="casino-and-virtual-game-links-inner">
            {
                skinType === "sport" ? sports.map(item => <div key={item.id}>
                    <Link className={item.alias} to={`/virtualGames/${item.alias}`}>
                        {t(item.alias)}
                    </Link>
                </div>) 
                : 
                skinType === "casino" ? 
                <>
                <div><Link className="casino" to="/casino">{t("Casino")}</Link></div>
                <div><Link className="dealer"  to="/dealer">{t("Dealer")}</Link></div>
                </>
                : 
                <>
                <div><Link className="casino" to="/casino">{t("Casino")}</Link></div>
                <div><Link className="dealer"  to="/dealer">{t("Dealer")}</Link></div>
                {/* <div><Link className="HorseRacingLink" to="/horseRacing/31">{t("Horse Racing")}</Link></div>
                <div><Link className="GreyhoundRacing" to="/greyhounds/184">{t("Greyhounds")}</Link></div> */}
                {
                     sports.map(item => <div key={item.id}>
                        <Link className={item.alias} to={`/virtualGames/${item.alias}`}>
                            {t(item.alias)}
                        </Link>
                    </div>) 
                }
                </>
               
            }
        </div>
    )
}

const mapStateToProps = (state, ownParams) => {
    let key = getSwarmDataKeyForRequest(getSportsListSubscriptionRequest(ownParams.selectedProvider));
    return createSelector(
        [
            state => JSON.stringify(state.swarmData?.data?.[key]),
        ],
        (data) => {
            data = data && JSON.parse(data);
            return {
                data,
            };
        }
    );
};

export default connect(mapStateToProps)(SwarmDataMixin(
    {
        Component: UIMixin({ Component: CasinoAndVirtualGameLinks }),
        ComponentWillMount: function () {
            let { selectedProvider } = this.props;
            this.swarmSubscriptionRequest = getSportsListSubscriptionRequest(selectedProvider);
            this.swarmDataKey = getSwarmDataKeyForRequest(getSportsListSubscriptionRequest(selectedProvider));
        }
    }
));